import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Header } from './Header'
import { Body } from './Body'

const getBodyProps = ({
  step,
  participant,
  address,
  handleStepChange,
  handleConfirmAddress,
  cart: { updateShippingAddress },
  fetchShipping
}) => {
  let shippingAddressData = address || {}
  let participantAddress = (participant && participant.address) || {}
  let disabledZipcode =
    participantAddress.zipCode && participantAddress.zipCode.disabled
  let disabledNumber =
    participantAddress.number && participantAddress.number.disabled
  let disabledComplement =
    participantAddress.complement && participantAddress.complement.disabled
  let disabledStreet =
    participantAddress.street && participantAddress.street.disabled
  let disabledDistrict =
    participantAddress.district && participantAddress.district.disabled
  let disabledCity = participantAddress.city && participantAddress.city.disabled
  let disabledState =
    participantAddress.state && participantAddress.state.disabled
  let disabledReference =
    participantAddress.reference && participantAddress.reference.disabled
  return {
    step,
    handleStepChange,
    handleConfirmAddress,
    isLoading: address.isLoading,
    zipCode:
      address && address.zipCode
        ? {
          value: address.zipCode,
          disabled: disabledZipcode
        }
        : { value: '', disabled: disabledZipcode },
    receiver: participant.name,
    updateShippingAddress,
    fetchShipping,
    cepError: address.cepError,
    number: shippingAddressData.number
      ? {
        value: shippingAddressData.number,
        disabled: disabledNumber
      }
      : { value: '', disabled: disabledNumber },
    complement: shippingAddressData.complement
      ? {
        value: shippingAddressData.complement,
        disabled: disabledComplement
      }
      : { value: '', disabled: disabledComplement },
    street: address.street
      ? {
        value: address.streetType + ' ' + address.street,
        valueParticipant: address.streetType + ' ' + address.street,
        disabled: disabledStreet
      }
      : { value: '', valueParticipant: '', disabled: disabledStreet },
    district: address.district
      ? {
        value: address.district,
        valueParticipant: address.district,
        disabled: disabledDistrict
      }
      : { value: '', valueParticipant: '', disabled: disabledDistrict },
    city: address.city
      ? {
        value: address.city,
        disabled: disabledCity
      }
      : { value: '', disabled: disabledCity },
    state: address.state
      ? {
        value: address.state,
        disabled: disabledState
      }
      : { value: '', disabled: disabledState },
    reference: shippingAddressData.reference
      ? {
        value: shippingAddressData.reference,
        disabled: disabledReference
      }
      : { value: '', disabled: disabledReference }
  }
}

class ShippingAddress extends Component {
  render () {
    const { step, cart } = this.props
    const props = getBodyProps(this.props)

    return (
      <div className='col-12' data-index='2'>
        <Header
          step={step}
          handleStepChange={this.props.handleStepChange}
          deliveryDate={cart.shipping.maxDeliveryDate}
          description={`${props.street.value}, ${props.number.value} - ${props.complement.value}`}
        />
        {step === 1 ? <Body {...props} /> : ''}
      </div>
    )
  }
}

ShippingAddress.propTypes = {
  participant: PropTypes.object,
  step: PropTypes.number,
  cart: PropTypes.object,
  handleStepChange: PropTypes.func,
  fetchShipping: PropTypes.func.isRequired,
  address: PropTypes.object
}

export default ShippingAddress



// WEBPACK FOOTER //
// ./src/features/Checkout/ShippingAddress/ShippingAddress.js